import { FinancialApplicationFormSectionSummary } from "../FinancialApplicationFormSectionSummary/FinancialApplicationFormSectionSummary";
import { FIELD_KEYS } from "@/constants";
import { useFieldSchemaToGetDataForSummary } from "../FinancialApplicationFormSectionSummary/useFieldSchemaToGetDataForSummary";
import { FieldInput } from "@/utils/getFieldSchemaData";
import { SUBSTEP_PATHS } from "@/config/stepPaths";

export interface OrganizationInformationSummaryProps {
    financialApplicationId: string;
}

const fieldsToInclude: FieldInput[] = [
    {
        fieldProps: FIELD_KEYS.FINANCIAL_APPLICATION.ORGANIZATION_INFORMATION,
    },
    {
        fieldProps: FIELD_KEYS.FINANCIAL_APPLICATION.ORGANIZATION_CONTACT_INFORMATION,
    }
];

export const OrganizationInformationSummary: React.FC<OrganizationInformationSummaryProps> = ({
    financialApplicationId,
}) => {
    const summaryData = useFieldSchemaToGetDataForSummary(financialApplicationId, fieldsToInclude);

    return (
        <FinancialApplicationFormSectionSummary
            title="Entity Information"
            data={summaryData}
            navigateTo={`/step/${SUBSTEP_PATHS.EntityInfo.EntityBasicInfo}`}
        />
    );
}; 